"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EvolutionBannerBackground = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const EvolutionBannerBackground = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  height: "1268",
  viewBox: "0 0 1699 1268",
  width: "1699",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/_react.default.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "m0 0h1699v1268h-1699z"
})), /*#__PURE__*/_react.default.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/_react.default.createElement("path", {
  clipRule: "evenodd",
  d: "m0 0h1699v1268.8h-1699z",
  fill: "#371526",
  fillRule: "evenodd"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "m572.286 1186.2c349.927 0 633.604-283.854 633.604-634.003 0-350.148-283.677-633.9997-633.604-633.9997-349.928 0-633.6005 283.8517-633.6005 633.9997 0 350.149 283.6725 634.003 633.6005 634.003z",
  fill: "#672146"
})));
exports.EvolutionBannerBackground = EvolutionBannerBackground;
//# sourceMappingURL=EvolutionBannerBackground.js.map